class CartOrderManagementController {
    constructor(orderManagementService) {
        this.orderManagement = orderManagementService;
    }

    $onInit() {
        this.orderManagement.getTotalOrderCount().then((count) => {
            this.orderCount = count;
        });

        this.shouldShowOrderManagement = false;
    }
}

const cartOrderManagementComponentDefinition = {
    bindings: {
        toggleOrderManagement: '&',
    },
    controller: ['OrderManagementService', CartOrderManagementController],
    template: require('./cart-order-management.component.html').trim(),
};

module.exports = {
    CartOrderManagementController,
    cartOrderManagementComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-order-management.component.js